<template>
  <v-layout>
    <slot
      v-if="authorizationCheck || showContent"
      v-bind:authorization="authorizationCheck"
      :is-read-only="isReadOnly"
      :can-save="canSave"
      :can-delete="canDelete"
      :can-print="canPrint"
      :can-action="canAction"
      :can-access-unit="canAccessUnit"
    />
    <slot name="unauthorized" v-else />
  </v-layout>
</template>

<script>
export default {
  name: "authorizationTwo",
  props: {
    permissionKey: [String, Array],
    can: String,
    comparisonMethod: {
      type: String,
      default: "or",
    },
  },
  computed: {
    currentUnitId() {
      return this.$store.state.authentication.unitSelected?.id || "global";
    },
    currentUnitPermissions() {
      const all = this.$store.state.authorization.authorizations || {};
      return all[this.currentUnitId] || [];
    },
    authorizationCheck() {
      const authorizations = this.lodash.filter(
        this.currentUnitPermissions,
        (e) => {
          if (Array.isArray(this.permissionKey)) {
            return this.permissionKey.includes(e.permissionKey);
          }
          return e.permissionKey === this.permissionKey;
        }
      );

      if (this.comparisonMethod === "or") {
        return authorizations.some((auth) =>
          auth.can.includes(this.can)
        );
      }

      if (this.comparisonMethod === "and") {
        return authorizations.every((auth) =>
          auth.can.includes(this.can)
        );
      }

      return false;
    },
    showContent() {
      return this.can !== "read";
    },
    isReadOnly() {
      return this.hasPermission("read");
    },
    canSave() {
      return this.hasPermission("save");
    },
    canDelete() {
      return this.hasPermission("delete");
    },
    canPrint() {
      return this.hasPermission("print");
    },
    canAction() {
      return this.hasPermission("action");
    },
    canAccessUnit() {
      return this.hasPermission("unit");
    }
  },
  methods: {
    hasPermission(permission) {
      const authorizations = this.lodash.filter(
        this.currentUnitPermissions,
        (e) => {
          if (Array.isArray(this.permissionKey)) {
            return this.permissionKey.includes(e.permissionKey);
          }
          return e.permissionKey === this.permissionKey;
        }
      );

      return authorizations.some((auth) =>
        auth.can.includes(permission)
      );
    }
  },
};
</script>

<style lang="scss" scoped>
.layout {
  flex: none;
  display: contents;
}
</style>
